import { differenceInSeconds } from "date-fns";
import { pad } from "./helpers";

const countdownEl = document.getElementById("countdown");
let daysEl, hoursEl, minutesEl, secondsEl, endDate;

function checkTime() {
    var now = new Date();
    var start = new Date(endDate);

    var totalSeconds = differenceInSeconds(start, now);

    var days = totalSeconds >= 0 ? Math.floor(totalSeconds / (3600 * 24)) : 0;
    var hours = totalSeconds >= 0 ? Math.floor((totalSeconds % (3600 * 24)) / 3600) : 0;
    var minutes = totalSeconds >= 0 ? Math.floor((totalSeconds % 3600) / 60) : 0;
    var seconds = totalSeconds >= 0 ? Math.floor(totalSeconds % 60) : 0;

    daysEl.querySelector('.value').innerHTML = pad(days, 2, "0");
    daysEl.querySelector('.label').innerHTML = days == 1 ? "Dag" : "Dagen";
    hoursEl.querySelector('.value').innerHTML = pad(hours, 2, "0");
    minutesEl.querySelector('.value').innerHTML = pad(minutes, 2, "0");
    secondsEl.querySelector('.value').innerHTML = pad(seconds, 2, "0");
}

export default function () {
    if (countdownEl) {
        endDate = countdownEl.dataset.endDate;
        daysEl = document.getElementById("countdown-days");
        hoursEl = document.getElementById("countdown-hours");
        minutesEl = document.getElementById("countdown-minutes");
        secondsEl = document.getElementById("countdown-seconds");

        checkTime();
        setInterval(() => checkTime(), 1000);
    }
}
